import { Reducer } from 'redux'
import { FORM_LOADED } from '../form/constants'
import { ActionTypes as CitationActionTypes } from '../citation/constants'
import { ActionTypes } from './constants'
import { Action, CreateCitationState } from './types'

export const initialState: CreateCitationState = {
  loading: true,
  query: '',
  sources: [],
  sourceType: '',
  journalType: 'journal',
  autociteV0RioOptFlag: false,
  autociteApiVersion: 'v0',
}

export const createCitationReducer: Reducer<CreateCitationState, Action> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CitationActionTypes.CITATION_LOAD:
      return action.payload.query
        ? { ...state, query: action.payload.query }
        : { ...state }
    case ActionTypes.CREATE_CITATION_SOURCE_TYPE_SELECTED:
      return { ...state, loading: true, sourceType: action.payload.sourceType }
    case ActionTypes.CREATE_CITATION_QUERY_ENTERED:
      return { ...state, loading: true, query: action.payload.query, sources: [] }
    case ActionTypes.CREATE_CITATION_SEARCH_RESULTS_PAGE_LOADED:
      return {
        ...state,
        loading: true,
        sourceType: action.payload.sourceType,
        query: action.payload.query,
        sources: [],
      }
    case ActionTypes.CREATE_CITATION_SEARCH_SUCCEEDED:
      return { ...state, loading: false, sources: action.payload.sources, error: '' }
    case ActionTypes.CREATE_CITATION_SEARCH_FAILED:
      return { ...state, loading: false, error: action.payload.message }
    case ActionTypes.SOURCE_SELECTION_COMPLETED:
      return { ...state, selectedSource: action.payload.selectedSource }
    case ActionTypes.CREATE_CITATION_JOURNAL_TAB_SELECTED:
      return { ...state, loading: true, sources: [], journalType: action.payload.type }
    case ActionTypes.SET_AUTOCITE_V0_RIO_OPT_FLAG:
      return { ...state, autociteV0RioOptFlag: action.payload.autociteV0RioOptFlag }
    case ActionTypes.SET_AUTOCITE_API_VERSION:
      return { ...state, autociteApiVersion: action.payload.autociteApiVersion }
    case FORM_LOADED:
      return { ...state, sourceType: action.payload.sourceType }
    default:
      return state
  }
}

export default createCitationReducer
